import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs))

export const LOCALE_MAP: Record<string, string> = {
    en: "en-US",
    cs: "cs-CZ",
}

export const formatCurrency = (minorUnits: number, currency = "CZK", locale = "en-US"): string => {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
    }).format(minorUnits / 100)
}

export const formatDate = (isoDate: string, locale = "en-US"): string => {
    return new Intl.DateTimeFormat(locale, { dateStyle: "medium" }).format(new Date(isoDate))
}

export const formatDateRange = (from: string, to: string, locale = "en-US"): string =>
    `${formatDate(from, locale)} – ${formatDate(to, locale)}`
